import { h } from "preact";
import { Text } from "../../../components/text";
import { IColumnData } from "../interfaces/table";

export const COULMN_DATA = (): IColumnData[] => [
  {
    title: "ลำดับ",
    dataIndex: "index",
    key: "index",
    width: "4em",
  },
  {
    title: "หมายเลขเครื่องตัด",
    dataIndex: "deviceID",
    key: "deviceID",
    width: "10em",
    render: (text: any, _record) => {
      return (
        <Text
          size={"S"}
          text={text as string}
          bold={true}
          color={_record.statusName === "WAITING-QC" ? "" : "white"}
        />
      );
    },
  },
  {
    title: "วันที่ QC",
    dataIndex: "qcDate",
    key: "qcDate",
    width: "10em",
  },
  {
    title: "ลักษณะเครื่อง",
    dataIndex: "deviceType",
    key: "deviceType",
    width: "10em",
  },
  {
    title: "ขนาดเครื่อง",
    dataIndex: "deviceSize",
    key: "deviceSize",
    width: "10em",
  },
];
